import { dashboardApiMiddleware } from "../api.middlewares";
import { AppRequiredMinimumVersion } from "./version.interface";

export const getAppRequiredMinimumVersion = dashboardApiMiddleware<AppRequiredMinimumVersion>()({
  method: "get",
  endpoint: "/api/version/app/check_update_requirements",
});
